import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer";
import { Subscription } from "rxjs/Subscription";
import { ConstantsStore } from "@store/constants";
import { Term } from "@models/term";
import { MatrixClass } from "@models/matrix-class";
import { MatrixClassesStore } from "@store/matrix-classes";
import {
  FETCH_CLASSSES_FOR_TO_TERM,
  FETCH_CLASSSES_FOR_FROM_TERM,
  POPULATE_CLASS_ROLLOVER_RESULT,
  CLASS_ROLLOVER_FAILURE,
  CLASS_ROLLOVER
} from "@reducers/matrix-class";
import { ClassRolloverParams } from "@services/matrix-class";

@Component({
  selector: 'class-rollover-view',
  templateUrl: './class-rollover-view.pug',
})
export class ClassRolloverViewComponent implements OnInit, OnDestroy {

  private constantsSubscription: Subscription
  private classesSubscription: Subscription

  public terms: Term[]
  public termFromSearchStr: string
  public termsFromCompleter: CompleterData
  public termToSearchStr: string
  public termsToCompleter: CompleterData

  public termFrom: Term
  public termTo: Term

  public isSuccessMessageVisible: boolean = false
  public isFailureMessageVisible: boolean = false

  public classesTermFrom: MatrixClass[] = []
  public classesTermTo: MatrixClass[] = []

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private actions: Actions
  ) {}

  ngOnInit() {
    this.constantsSubscription =
      this.store.select('constantsReducer').subscribe(
        (s: ConstantsStore) => this.terms = s.constants.terms)

    this.classesSubscription =
      this.store.select('matrixClassesReducer').subscribe(
        (s: MatrixClassesStore) => {
          this.classesTermFrom = s.classesRolloverTermFrom
          this.classesTermTo = s.classesRolloverTermTo
        })

    this.setupCompleters()
  }

  setupCompleters() {
    this.termsFromCompleter =
      this.completerService.local(this.terms, "name", "name")
    this.termsToCompleter =
      this.completerService.local(this.terms, "name", "name")
  }

  selectedTermFrom(e: CompleterItem) {
    if (e) {
      this.termFrom = e.originalObject as Term
    }
    else {
      this.termFrom = null
    }
    this.refreshTerm('from')
  }

  selectedTermTo(e: CompleterItem) {
    if (e) {
      this.termTo = e.originalObject as Term
    }
    else {
      this.termTo = null
    }
    this.refreshTerm('to')
  }

  refreshTerm(termType: string) {
    let actionType: string
    let targetTermId: number

    if (termType == "from") {
      actionType      = FETCH_CLASSSES_FOR_FROM_TERM
      targetTermId    = this.termFrom.id
    }
    else if (termType == "to") {
      actionType      = FETCH_CLASSSES_FOR_TO_TERM
      targetTermId    = this.termTo.id
    }

    this.store.dispatch({ type: actionType, payload: targetTermId })
  }

  clickedRollover() {
    this.setupResultSubscriptions()

    const params: ClassRolloverParams = {
      from_term_id: this.termFrom.id,
      to_term_id: this.termTo.id,
    }

    this.store.dispatch({ type: CLASS_ROLLOVER, payload: params })
  }

  setupResultSubscriptions() {
    this.actions
      .ofType(POPULATE_CLASS_ROLLOVER_RESULT, CLASS_ROLLOVER_FAILURE)
      .take(1)
      .subscribe((a: Action) => {
        if (a.type == POPULATE_CLASS_ROLLOVER_RESULT) {
          this.isSuccessMessageVisible = true
        }
        else if (a.type == CLASS_ROLLOVER_FAILURE) {
          this.isFailureMessageVisible = true
        }
      })
  }

  ngOnDestroy() {
    this.constantsSubscription.unsubscribe()
    this.classesSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/class-rollover-view.ts